import { Image } from 'lucide-react'

type Props = { props: Record<string, string | number | boolean> }

export function ImageGalleryPreview({ props: p }: Props) {
  const images = [p.imageUrl1, p.imageUrl2, p.imageUrl3].filter(Boolean) as string[]
  const cols = Number(p.columns) || 3
  const gap = Number(p.gap) || 8

  return (
    <div className="grid" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: `${gap}px` }}>
      {images.length > 0 ? (
        images.map((url, i) => (
          <img key={i} src={url} alt={`Gallery ${i + 1}`} className="w-full h-24 object-cover rounded" />
        ))
      ) : (
        Array.from({ length: cols }).map((_, i) => (
          <div key={i} className="w-full h-24 bg-tf-bg-hover rounded flex items-center justify-center">
            <Image className="w-6 h-6 text-tf-text-muted" />
          </div>
        ))
      )}
    </div>
  )
}
